import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as hooks from "../../utils/hooks";

import * as func from '../../utils/functions';
import SearchSide from "../../components/search/front/list/side";
import JournalLite from "../../components/search/front/list/journalLite";
import ResourceLite from "../../components/search/front/list/resourceLite";
import ScholarLite from "../../components/search/front/list/scholarLite";

class TotalSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInitJ: false,
            isInitR: false,
            isInitS: false,
            journalRecords : [],
            journalFoundRecords : 0,
            resourceRecords : [],
            resourceFoundRecords : 0,
            scholarRecords : [],
            scholarFoundRecords : 0,
        }
    }

    componentDidMount() {
        hooks.menuHook(this);
        // 이해 안됨.
        setTimeout(() => {
            this.getList();
        }, 0);
    }

    getList() {
        const p = {
            'current_page' : 1,
            'record_per_page' : 3,
            'ks' : func.getParams('ks'),
            'order_by' : 'date',
            'order' : 'desc',
        };
        func.getData("journals", p).then((response) => {
            this.setState({
                isInitJ: true,
                'journalRecords' : response.records,
                'journalFoundRecords' : response.pageInfo.totalResults
            })
        });

        func.getData("resources", p).then((response) => {
            this.setState({
                isInitR: true,
                'resourceRecords' : response.records,
                'resourceFoundRecords' : response.pageInfo.totalResults
            })
        });

        func.getData("scholars", p).then((response) => {
            this.setState({
                isInitS: true,
                'scholarRecords' : response.records,
                'scholarFoundRecords' : response.pageInfo.totalResults
            })
        });
    }

    render() {
        return (
            <div className="contents-group">
                <div className="center-group">
                    <JournalLite records={this.state.journalRecords} foundRecord={this.state.journalFoundRecords} isInit={this.state.isInitJ}/>
                    <ResourceLite records={this.state.resourceRecords} foundRecord={this.state.resourceFoundRecords} isInit={this.state.isInitR}/>
                    <ScholarLite records={this.state.scholarRecords} foundRecord={this.state.scholarFoundRecords} isInit={this.state.isInitS}/>
                </div>
                <SearchSide />
            </div>
        )
    }
}

export default connect(
    (state) => ({
        // args: state.journals.args ? state.journals.args : {},
        // records : state.journals.records ? state.journals.records : [],
        // facet : state.journals.facet ? state.journals.facet : {},
        // totalRecords : state.journals.totalRecords ? state.journals.totalRecords : 0,
        // totalPage : state.journals.totalPage ? state.journals.totalPage : 0,
    }),
    (dispatch) => ({
        // jDataActions: bindActionCreators(jDataActions, dispatch)
    }),
)(TotalSearch)

TotalSearch.propTypes = {
    // args : PropTypes.object,
    // records : PropTypes.array,
    // facet : PropTypes.object,
    // totalRecords : PropTypes.number,
    // totalPage : PropTypes.number,
};
